import { executeMutation } from 'services/graphQL/clientService.js';
import gql from 'graphql-tag';

const mutation = gql`
  mutation RemoveAllTeamProfiles($input: RemoveAlTeamProfilesInput!) {
    removeAllTeamProfiles(input: $input) {
      success
      errors
    }
  }
`;

export default function removeAllProfiles(input) {
  return executeMutation(mutation, { input });
}
